export function solidStyle(color: string): {
    backgroundColor: string;
    borderColor: string;
    textColor: string;
} {
    return {
        textColor: "white",
        backgroundColor: color,
        borderColor: color,
    };
}

export function outlineStyle(
    color: string,
    backgroundColor = "transparent",
): {
    backgroundColor: string;
    borderColor: string;
    textColor: string;
} {
    return {
        textColor: color,
        backgroundColor: backgroundColor,
        borderColor: color,
    };
}

export function textStyle(
    color: string,
    backgroundColor = "transparent",
): {
    backgroundColor: string;
    borderColor: string;
    textColor: string;
} {
    return {
        textColor: color,
        backgroundColor: backgroundColor,
        borderColor: "transparent",
    };
}
